import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { routes } from "@bezoned/shared/routes.js";
import {
  Body1,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Title3,
} from "@fluentui/react-components";
import { useLocation, useNavigate } from "react-router-dom";

import { updateSearchParams } from "../../utils/url-search-params.js";

export const NotATeamMemberScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClick30 = useStableCallback(() =>
    navigate(
      `${routes.protected.chooseTeam}${updateSearchParams(location.search, {
        remove: ["teamId"],
      })}`
    )
  );

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-4">
      <Card className="w-full max-w-md" size="large">
        <CardHeader header={<Title3>No access</Title3>} />

        <Body1>
          You do not have access to this office. Please contact your admin if
          you need access.
        </Body1>

        <CardFooter className="flex items-center justify-end">
          <Button appearance="primary" onClick={handleClick30} type="button">
            Back to lobby
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
